import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  PLATFORM_ID
} from "@angular/core";
import { UserServiceService } from "../user-service.service";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { Router } from "@angular/router";
import { Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Location, isPlatformBrowser } from "@angular/common";
import { environment } from "../../environments/environment";
import { LoginService } from "../login.service";
import { ToastService } from "../toast.service";

declare const google: any;
import { LazyImgDirective } from "../lazy-img.directive";
import { FormsModule } from "@angular/forms";
import { MatFormField, MatError , MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatCard } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { MatSelect, MatOption } from "@angular/material/select";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LazyImgDirective,
    FormsModule,
    MatFormField, MatLabel, MatSuffix,
    MatInput,
    MatIconButton, MatButton,
    MatCard,
    MatIcon,
    RouterLink,
    MatSelect,
    MatOption,
    MatError
  ]
})
export class LoginPageComponent implements OnInit, AfterViewInit {
  personRe: boolean = true;
  loginpe: boolean = false;
  model: any = {};
  users: any;
  returnUrl: any;
  model2: any = {};
  model3: any = {};
  countrycode: any;
  m_verify: boolean = false;
  is_verify: boolean = false;
  verification_code: boolean = false;
  temp: any;

  // Cloudflare Turnstile (bot check before the OTP send).
  turnstileSiteKey: string = environment.turnstileSiteKey;
  turnstileToken: string = "";
  private turnstileWidgetId: any = null;

  constructor(
    private _location: Location,
    private service: UserServiceService,
    private route: Router,
    private router: ActivatedRoute,
    private dialog: MatDialog,
    private loginService: LoginService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(PLATFORM_ID) private platformId: any,
    private cdr: ChangeDetectorRef,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.returnUrl = this.router.snapshot.queryParams["returnUrl"] || "/";
    if (this.loginService.switch_to_register === true) {
      this.loginService.switch_to_register = false;
      this.switch_to_reg_page();
    }
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    this.loadTurnstileScript();
    this.renderGoogleButton();
  }

  private googleInited = false;

  // Render the official Google "Continue with Google" button into #googleBtn
  // (present in whichever card — sign-in or sign-up — is currently shown).
  private renderGoogleButton(attempt = 0) {
    if (!isPlatformBrowser(this.platformId)) return;
    if (typeof google === "undefined" || !google.accounts || !google.accounts.id) {
      if (attempt < 40) { setTimeout(() => this.renderGoogleButton(attempt + 1), 100); }
      return;
    }
    if (!this.googleInited) {
      google.accounts.id.initialize({
        client_id: environment.googleClientId,
        callback: (resp: any) => this.googleLogin(resp.credential)
      });
      this.googleInited = true;
    }
    const el = document.getElementById("googleBtn");
    if (el) {
      el.innerHTML = "";
      google.accounts.id.renderButton(el, { theme: "outline", size: "large", width: 320, text: "continue_with" });
    }
  }

  googleLogin(credential: string) {
    this.service.google_login(credential).subscribe((data: any) => {
      if (data["success"]) {
        localStorage.setItem("currentUser", JSON.stringify(data["data"]));
        this.toast.success(data["message"] || "Signed in");
        this.route.navigateByUrl(this.returnUrl);
      } else {
        this.toast.error(data["message"] || "Google sign-in failed");
      }
      this.cdr.markForCheck();
    });
  }

  private loadTurnstileScript() {
    const w = window as any;
    if (w.turnstile) { this.renderTurnstile(0); return; }
    if (!document.getElementById("cf-turnstile-script")) {
      const s = document.createElement("script");
      s.id = "cf-turnstile-script";
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      s.async = true;
      s.defer = true;
      s.onload = () => this.renderTurnstile(0);
      document.head.appendChild(s);
    } else {
      this.renderTurnstile(0);
    }
  }

  // Render the widget once its container is in the DOM and the script is ready.
  // Bounded retry (~10s) handles the container appearing after a view switch.
  renderTurnstile(attempt: number = 0) {
    if (!isPlatformBrowser(this.platformId)) { return; }
    if (this.turnstileWidgetId !== null) { return; }
    const w = window as any;
    const el = document.getElementById("trd-turnstile");
    if (!w.turnstile || !el) {
      if (attempt < 40) { setTimeout(() => this.renderTurnstile(attempt + 1), 250); }
      return;
    }
    try {
      this.turnstileWidgetId = w.turnstile.render(el, {
        sitekey: this.turnstileSiteKey,
        callback: (token: string) => { this.turnstileToken = token; this.cdr.markForCheck(); },
        "error-callback": () => { this.turnstileToken = ""; this.cdr.markForCheck(); },
        "expired-callback": () => { this.turnstileToken = ""; this.cdr.markForCheck(); }
      });
    } catch (e) { /* render failed — token stays empty */ }
  }

  private resetTurnstile() {
    const w = window as any;
    this.turnstileToken = "";
    if (w.turnstile && this.turnstileWidgetId !== null) {
      try { w.turnstile.reset(this.turnstileWidgetId); } catch (e) {}
    }
  }

  password: string = "";
  confirmPassword: string = "";
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  register() {
    // check if mobile is verified or not
    if (this.model2.password != this.model2.confirmpassword) {
      this.toast.error("Confirm password doesn't match");
      return;
    }
    if (!this.validatePassword()) {
      return;
    }
    if (!this.m_verify) {
      //If not verified then don't return and don't register user
      this.toast.error("Please verify your phone number first");
      return;
    }

    this.service.registration(JSON.stringify(this.model2)).subscribe(
      data => {
        console.log(data);
        if (data["success"]) {
          this.toast.success(data["message"]);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  function(value) {
    this.countrycode = value;
    this.model2.country_code = value;
  }

  validatePassword(): boolean {
    const password = this.model2.password;

    // Check length
    if (password.length < 8) {
      this.toast.error("Password must be at least 8 characters long.");
      return false;
    }

    // Check for at least one uppercase letter
    if (!/[A-Z]/.test(password)) {
      this.toast.error("Password must contain at least one uppercase letter.");
      return false;
    }

    // Check for at least one digit
    if (!/\d/.test(password)) {
      this.toast.error("Password must contain at least one digit.");
      return false;
    }
    return true;
  }

  phone_btn_onclick() {
    // check if mobile number and country code is provided by the user
    if (!this.model2.mobile || !this.model2.country_code) {
      this.toast.error("Please enter a phone number and select a country code");
      return;
    }

    // Require the Turnstile challenge when the widget is present (don't hard-block
    // if the script failed to load at all — the backend still gates the send).
    const w = window as any;
    if (isPlatformBrowser(this.platformId) && w.turnstile && this.turnstileWidgetId !== null && !this.turnstileToken) {
      this.toast.error("Please complete the verification challenge");
      return;
    }

    //adjust model object accordingly
    this.model3.phone_number = this.model2.mobile;
    this.model3.country_code = this.model2.country_code;
    this.model3.via = "sms";

    //call the api to send verification code to user's mobile
    this.service
      .verification_code_send_signup(
        this.model3.phone_number,
        this.model3.country_code,
        this.turnstileToken
      )
      .subscribe(dat => {
        let data = dat;
        if (data["success"]) {
          //if OTP sent successfully to user's mobile then store returned hash and chage verification_code flag also.
          this.verification_code = true;
          this.model3.hash = data["hash"];
          this.toast.info("OTP sent to your phone");
        } else {
          this.toast.error(data["message"] || "Could not send OTP. Please try again.");
        }
        // Turnstile tokens are single-use — force a fresh challenge for any resend.
        this.resetTurnstile();
        this.cdr.markForCheck();
      });
  }

  //Verify whether user enters correct otp or not
  verify_code() {
    this.service
      .verify_code_signup(
        this.model3.token,
        this.model3.phone_number,
        this.model3.hash
      )
      .subscribe(da => {
        let data = da;

        //if OTP verified successfully then if block will execute
        if (data["success"]) {
          this.toast.success("Phone number verified");
          this.verification_code = false;
          this.m_verify = true;
          this.is_verify = true;
        } else {
          this.toast.error("Incorrect OTP. Please try again.");
          this.verification_code = true;
          this.m_verify = false;
        }
        this.cdr.markForCheck();
      });
  }

  switch_to_login_page() {
    this.loginpe = false;
    this.personRe = true;
    setTimeout(() => this.renderGoogleButton(), 0);
  }

  switch_to_reg_page() {
    this.personRe = false;
    this.loginpe = true;
    // Signup form just became visible — render the Turnstile widget into it.
    this.renderTurnstile(0);
    setTimeout(() => this.renderGoogleButton(), 0);
  }

  login() {
    this.service
      .mail_checking_login(this.model2.user_id, this.model2.password)
      .subscribe(data => {
        if (data["success"]) {
          localStorage.setItem("currentUser", JSON.stringify(data["data"]));
          this.toast.success(data["message"] || "Signed in");
          this.route.navigateByUrl(this.returnUrl);
        } else {
          this.toast.error(data["message"] || "Invalid email or password");
        }
      });
  }
}
